import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import StudioCard from '@fiverr-private/seller_card/src/StudioCard';
import { getCurrentContent } from '../../utils/ugc/getCurrentContent';
import { formatStudio } from '../../utils/studios';
import ProfileCard from '../shared/ProfileCard';
import SafePureComponent from '../shared/SafePureComponent';

import './style.scss';

const GigStudioCard = ({ studio }) => {
    if (!studio) {
        return null;
    }

    const studioProps = formatStudio(studio);

    return (
        <ProfileCard>
            <StudioCard {...studioProps}/>
        </ProfileCard>
    );
};

GigStudioCard.propTypes = {
    studio: PropTypes.object
};

const mapStateToProps = ({ ugc }, { studio }) => {
    if (!studio) {
        return {};
    }

    const { studio: studioUGC } = getCurrentContent({ ugc });
    const info = {
        ...studio.info,
        ...studioUGC
    };

    return {
        studio: { ...studio, info }
    };
};

const ConnectedGigStudioCard = connect(mapStateToProps)(GigStudioCard);

export { GigStudioCard, ConnectedGigStudioCard };
export default SafePureComponent(ConnectedGigStudioCard);
